import { observer } from 'mobx-react';
import { ReactComponent as ProStar } from "../../svg/star.svg";
import { ReactComponent as Party } from "../../svg/party-icon.svg";
import React from 'react'

@observer
class PresetTemplate extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      displayWidth: 0,
      displayHeight: 0
    }
  }

  getCorrectSize(width, height){
    let prc = 0.14
    if(width < 900 || height < 800){
      prc = 0.175
    }
    if(width < 400 || height < 400){
      prc = 0.25
    }
    const newWidth = width * prc
    const newHeight = height * prc
    const res = {
      height: newHeight,
      width: newWidth
    }
    return res
  }

  componentDidMount(){
    const { height: templateHeight, width: templateWidth, maxWidth, calcMax } = this.props
    if(calcMax){
      const el = document.body
      const w = el.offsetWidth - 100
      const val = w / 4
      const prec = val / templateWidth
      this.setState({
        displayHeight: templateHeight * prec,
        displayWidth: val
      })
    }
    if(maxWidth){
      const prec = maxWidth / templateWidth
      this.setState({
        displayWidth: maxWidth,
        displayHeight: templateHeight * prec
      })
    }else{
      const { width, height } = this.getCorrectSize(templateWidth, templateHeight)
      this.setState({
        displayHeight: height,
        displayWidth: width
      })
    }
  }

  render(){
    const { title, height: templateHeight, width: templateWidth, free, publicTemplate, hideMarker, thumburl, custom, background, maxWidth, calcMax, icon, onClick, idx } = this.props
    const bgStyle = {}
    if(background){
      bgStyle.background = background
    }
    if(thumburl){
      bgStyle.backgroundImage = `url(${thumburl})`
      bgStyle.backgroundSize = 'cover'
      bgStyle.backgroundRepeat = 'no-repeat'
    }
    if(!thumburl && !background){
      bgStyle.background = 'transparent'
    }
    const { width, height } = this.getCorrectSize(templateWidth, templateHeight)
    let spanWidth = width
    let styleProps = {}
    if(maxWidth){
      styleProps.width = maxWidth + 'px'
      const prec = maxWidth / templateWidth
      styleProps.height = templateHeight * prec
    }else{
      styleProps = {
        height,
        width
      }
    }
    if(calcMax){
      const el = document.body
      const w = el.offsetWidth - 100
      const val = w / 4
      styleProps.width = val + 'px'
      spanWidth = val
      const prec = val / templateWidth
      styleProps.height = templateHeight * prec
    }
    return (
      <div className='preset-wrapper cursor-pointer'>
        <div 
          onClick={() => custom ? onClick({...this.props}) : onClick(templateWidth, templateHeight, title)}
          className='preset-template'
          style={{
            ...bgStyle,
            ...styleProps
          }}
        >
          {icon || undefined}
          {
            hideMarker ? (
              undefined
            )
            :
            (
              <>
                {
                  custom && !free && publicTemplate ? (
                    <div className='template-marker paid'>
                      <ProStar />
                      <span className='template-marker__text'>
                        PRO
                      </span>
                    </div>
                  )
                  :
                  custom && free && publicTemplate ? (
                    <div className='template-marker free'>
                      <span className='template-marker__text'>
                        <Party />
                        FREE
                      </span>
                    </div>
                  )
                  :
                  undefined
                }
              </>
            )
          }
        </div>
        {
          custom ? undefined
          :
          (
            <>
              <span 
                style={{
                  whiteSpace: 'pre-wrap',
                  maxWidth: spanWidth + 'px'
                }}
                className='preset-template-title'>
                {title}{' '}
              </span>
              <span className='preset-template-size'>
                {templateWidth} x {templateHeight} px
              </span>
            </>
          )
        }
      </div>
    )
  }

}

export default PresetTemplate